import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxNumber from '../../cx/CxNumber';
import CxCombo from '../../cx/CxCombo';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxLink from '../../cx/CxLink';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxRegion from '../../fx/FxRegion';
import * as FxBrowser from '../../fx/FxBrowser';
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import { StoreRxAutoPs, } from "../../gx/GxStore";
import CimavetSVG from '../../svg/CimavetSVG.jsx';
import MxPsRxAutoCimavetDlg from './MxPsRxAutoCimavetDlg';

const MxPsRxAutoForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  // eslint-disable-next-line no-unused-vars
  const [storeRxAutoPs, setStoreRxAutoPs] = useSessionStorage('StoreRxAutoPs', StoreRxAutoPs);

  const [urlTechSheet, setUrlTechSheet] = React.useState('');

  let r_form = React.useRef(null);
  const r_dlg_cimavet = React.useRef(null);

  const rf_txRegime = React.useRef(null);
  const rf_txTypeDispensing = React.useRef(null);
  const rf_txTypeTreatment = React.useRef(null);
  const rf_txCode = React.useRef(null);
  const rf_txDrugStrength = React.useRef(null);
  const rf_txNature = React.useRef(null);
  const rf_txPharmaceuticalForm = React.useRef(null);
  const rf_txRouteAdministration = React.useRef(null);
  const rf_txActiveIngredient = React.useRef(null);
  const rf_txDosageInformation = React.useRef(null);
  const rf_nuDrugPerc = React.useRef(null);
  const rf_txDurationTreatment = React.useRef(null);
  const rf_txWithdrawalMilk = React.useRef(null);
  const rf_txWithdrawalMeat = React.useRef(null);
  const rf_txWithdrawalEggs = React.useRef(null);
  const rf_txDirections = React.useRef(null);


  const r_snack_ask_save = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    navBack();
  }
  const formDelete = async (rv) => {
  }

  const doCimavetInsert = (drugData) => {
    FxLog.infox('MxPsRxAutoForm.doCimavetInsert', '...drugData:', drugData);
    if (rf_txRegime.current.isEmpty()) rf_txRegime.current.setVal(trans('field.regular'));
    rf_txTypeDispensing.current.setKeyAndVal2(drugData.txTypeDispensing);
    rf_txTypeTreatment.current.setKeyAndVal2(drugData.txTypeTreatment);
    rf_txCode.current.setVal(drugData.txCode);
    rf_txDrugStrength.current.setVal(drugData.txDrugStrength);
    rf_txNature.current.setVal(drugData.txNature);

    rf_txPharmaceuticalForm.current.setVal(drugData.txPharmaceuticalForm);
    rf_txRouteAdministration.current.setVal(drugData.txRouteAdministration);
    rf_txActiveIngredient.current.setVal(drugData.txActiveIngredient);
    rf_txDosageInformation.current.setVal(drugData.txDosageInformation);
    rf_nuDrugPerc.current.setVal(drugData.nuDrugPerc);
    rf_txDurationTreatment.current.setVal(drugData.txDurationTreatment);
    rf_txWithdrawalMilk.current.setVal(drugData.txWithdrawalMilk);
    rf_txWithdrawalMeat.current.setVal(drugData.txWithdrawalMeat);
    rf_txWithdrawalEggs.current.setVal(drugData.txWithdrawalEggs);
    setUrlTechSheet(drugData.url);
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.ps')}: ${trans('field.rx')}: ${storeRxAutoPs.txPs}`}
        xref={r_form}
        url="pss/rx_auto" 
        filterIdField='itRxAuto' 
        filterIdValue={storeRxAutoPs.itRxAuto} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            {/* botón importar de cimavet */}
            {FxRegion.isSpain() && <CxIconButtonNew 
              icon={<CimavetSVG fill='var(--ibs_color_blue)' width="70.00px" height="20.00px" />} 
              classType="ibs_iconbutton_toolbar" 
              onClick={() => r_dlg_cimavet.current.setOpenDlg(true)} 
              tooltip={'Importar datos de Cimavet'} 
            />}
            
          </div>
        }
        >
        <CxHidden xref={useRef(null)} dbfield="t_rx_auto.inPs" value={storeRxAutoPs.inPs || ''} />

        {urlTechSheet && <CxLink label={`[${trans('msg.see_x', 'Ficha Técnica').toUpperCase()}]`} style={{ margin: '0 0 0 0px', fontSize: '10px' }} 
          onClick={() => FxBrowser.windowOpen(urlTechSheet)} 
        />}


        <CxInput xref={rf_txRegime} label={trans('field.rx_regime')} dbfield="t_rx_auto.txRegime" maxLength='50' required />

        {/* 1-dispensación (almacenado en farmacia), 2-no-dispensación, 3-botiquín (almacenado en explotación) */} 
        <CxCombo xref={rf_txTypeDispensing}
          label={`${trans('field.rx_type_dispensing')}`}
          dbfield='t_rx_auto.txTypeDispensing'
          list={[
            { id: 'D', type: trans('field.rx_dispensing_dispensation') },
            { id: 'N', type: trans('field.rx_dispensing_dispensation_no') },
            { id: 'K', type: trans('field.rx_dispensing_kit') },
          ]}
          defaultValue='D'
          clearDisabled
        />
        
        {/* T-terapéutico, M-metafiláctico, P-profiláctico */}
        <CxCombo xref={rf_txTypeTreatment}
          label={`${trans('field.rx_type_treatment')}`}
          dbfield='t_rx_auto.txTypeTreatment'
          list={[
            { id: 'T', type: trans('field.rx_treatment_therapeutic') },
            { id: 'M', type: trans('field.rx_treatment_metaphylactic') },
            { id: 'P', type: trans('field.rx_treatment_prophylactic') },
          ]}
          defaultValue='T'
          clearDisabled
        />

        {FxRegion.isSpain() && <CxInput xref={rf_txCode} label={trans('field.rx_national_code')} dbfield="t_rx_auto.txCode" maxLength='30' onInfo={() => FxBrowser.windowOpen('https://cimavet.aemps.es/cimavet/publico/home.html')} />}
        {!FxRegion.isSpain() && <CxInput xref={rf_txCode} label={trans('field.rx_national_code')} dbfield="t_rx_auto.txCode" maxLength='30' />}
        <CxInput xref={rf_txDrugStrength} label={trans('field.rx_drug_strength')} dbfield="t_rx_auto.txDrugStrength" maxLength='255' /> 
        <CxInput xref={rf_txNature} label={trans('field.rx_nature')} dbfield="t_rx_auto.txNature" maxLength='255' />

        <CxInput xref={rf_txPharmaceuticalForm} label={trans('field.rx_pharmaceutical_form')} dbfield="t_rx_auto.txPharmaceuticalForm" maxLength='255' />
        <CxInput xref={rf_txRouteAdministration} label={trans('field.rx_route_administration')} dbfield="t_rx_auto.txRouteAdministration" maxLength='255' />
        <CxInput xref={rf_txActiveIngredient} label={trans('field.rx_active_ingredient')} dbfield="t_rx_auto.txActiveIngredient" maxLength='255' />
        <CxInput xref={rf_txDosageInformation} label={trans('field.rx_dosage_information')} dbfield="t_rx_auto.txDosageInformation" maxLength='255' />

        <CxNumber xref={rf_nuDrugPerc} label={trans('field.rx_drug_perc')} dbfield="t_rx_auto.nuDrugPerc" decimals={1} decimalsfixed="false" defaultValue={100} />
        <CxInput xref={rf_txDurationTreatment} label={trans('field.rx_duration_treatment')} dbfield="t_rx_auto.txDurationTreatment" maxLength='255' />

        <CxInput xref={rf_txWithdrawalMilk} label={trans('field.rx_withdrawal_milk')} dbfield="t_rx_auto.txWithdrawalMilk" maxLength='255' />
        <CxInput xref={rf_txWithdrawalMeat} label={trans('field.rx_withdrawal_meat')} dbfield="t_rx_auto.txWithdrawalMeat" maxLength='255' />
        <CxInput xref={rf_txWithdrawalEggs} label={trans('field.rx_withdrawal_eggs')} dbfield="t_rx_auto.txWithdrawalEggs" maxLength='255' />
        
        <CxInput xref={rf_txDirections} label={trans('field.rx_directions')} dbfield="t_rx_auto.txDirections" maxLength='500' minRows={4} />

      </GxForm>

      <MxPsRxAutoCimavetDlg
        xref={r_dlg_cimavet}
        title={'Importar datos de Cimavet'}
        onResult={doCimavetInsert}
      />

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      
    </div>
  );

}

export default MxPsRxAutoForm;
